import { z } from 'zod'

export const creditDetailsResponseSchema = z.object({
  id: z.string().guid(),
  accountId: z.string().guid(),
  creditLimit: z.number(),
  closingDay: z.number().int().min(1).max(31),
  lastNotifiedClosingDate: z.coerce.date().nullable(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
})

export type CreditDetailsResponseDto = z.infer<typeof creditDetailsResponseSchema>
